import { defineMessages } from 'react-intl';
import aOrAn from 'indefinite';
import { SportTermLookup, SportTerminology } from '../../../lib/types';
import { pluralTerm } from '../../../lib/helpers/term.helper';

export const scope = 'app.components.UpdateCompanyForm';

export const getMessages = (termLookup: SportTermLookup) => {
  const athleteTerm = termLookup[SportTerminology.ATHLETE].toLowerCase();
  const sessionTerm = termLookup[SportTerminology.SESSION].toLowerCase();
  return defineMessages({
    lblCompanyWebsite: {
      id: `${scope}.lblCompanyWebsite`,
      defaultMessage: 'Association Website'
    },
    lblCompanyName: {
      id: `${scope}.lblCompanyName`,
      defaultMessage: 'Association Name',
    },
    lblCommunicationEmail: {
      id: `${scope}.lblCommunicationEmail`,
      defaultMessage: `Email to provide for ${pluralTerm(athleteTerm)} to reply-to:`
    },
    lblTimezone: {
      id: `${scope}.lblTimezone`,
      defaultMessage: 'Timezone'
    },
    titleCommunicationBranding: {
      id: `${scope}.titleCommunicationBranding`,
      defaultMessage: 'Communication Branding',
    },
    btnUploading: {
      id: `${scope}.btnUploading`,
      defaultMessage: 'Uploading...',
    },
    btnChangeLogo: {
      id: `${scope}.btnChangeLogo`,
      defaultMessage: 'Change Association Logo',
    },
    errUploadLogo: {
      id: `${scope}.errUploadLogo`,
      defaultMessage: `Couldn't upload the association logo. Please try again.`,
    },
    titleAttendance: {
      id: `${scope}.titleAttendance`,
      defaultMessage: 'Attendance',
    },
    btnApplying: {
      id: `${scope}.btnApplying`,
      defaultMessage: 'Applying...',
    },
    btnApplyDefault: {
      id: `${scope}.btnApplyDefault`,
      defaultMessage: 'Apply default to existing assessments',
    },
    helpSaveFirstToApply: {
      id: `${scope}.helpSaveFirstToApply`,
      defaultMessage: 'Save your settings first to apply the latest default.',
    },
    helpApplyScopeApplies: {
      id: `${scope}.helpApplyScopeApplies`,
      defaultMessage: 'Applies the saved default to assessments that have never had an attendance default set.',
    },
    helpApplyScopeUnchanged: {
      id: `${scope}.helpApplyScopeUnchanged`,
      defaultMessage: 'Assessments with an explicit setting are left unchanged.',
    },
    msgAppliedToAssessments: {
      id: `${scope}.msgAppliedToAssessments`,
      defaultMessage: 'Applied to {count} {assessments} that had no attendance default set.',
    },
    errApplyDefaultFailed: {
      id: `${scope}.errApplyDefaultFailed`,
      defaultMessage: `Couldn't apply the default to existing assessments. Please try again.`,
    },
    titleReportCards: {
      id: `${scope}.titleReportCards`,
      defaultMessage: 'Report Cards',
    },
    titleJerseys: {
      id: `${scope}.titleJerseys`,
      defaultMessage: 'Jerseys',
    },
    titleCalibration: {
      id: `${scope}.titleCalibration`,
      defaultMessage: 'Calibration',
    },
    descCalibration: {
      id: `${scope}.descCalibration`,
      defaultMessage: 'Calibration periodically asks evaluators to re-score a set of reference videos, so scoring stays consistent across your evaluators.',
    },
    btnSaving: {
      id: `${scope}.btnSaving`,
      defaultMessage: 'Saving...',
    },
    btnSaveSettings: {
      id: `${scope}.btnSaveSettings`,
      defaultMessage: 'Save Settings',
    },
    lblLevelAssignmentCopy: {
      id: `${scope}.lblLevelAssignmentCopy`,
      defaultMessage: `When you notify a ${athleteTerm} about their assigned level:`
    },
    lblTeamAssignmentCopy: {
      id: `${scope}.lblTeamAssignmentCopy`,
      defaultMessage: `When you notify a ${athleteTerm} about their assigned team:`
    },
    lblEvaluationsConcludedCopy: {
      id: `${scope}.lblEvaluationsConcludedCopy`,
      defaultMessage: `When a ${athleteTerm} has finished their scheduled evaluations:`,
    },
    lblReportCardCopy: {
      id: `${scope}.lblReportCardCopy`,
      defaultMessage: `When a ${athleteTerm} is send their report card:`,
    },
    lblHoldPlayerCopy: {
      id: `${scope}.lblHoldPlayerCopy`,
      defaultMessage: `When a ${athleteTerm} is put on hold during evaluation scheduling:`
    },
    lblIceTimeCancelledCopy: {
      id: `${scope}.lblIceTimeCancelledCopy`,
      defaultMessage: `When ${aOrAn(sessionTerm)} is cancelled:`
    },
    lblIceTimeUpdateCopy: {
      id: `${scope}.lblIceTimeUpdateCopy`,
      defaultMessage: `When ${aOrAn(sessionTerm)} is updated:`,
    },
    lblIceTimeReminderCopy: {
      id: `${scope}.lblIceTimeReminderCopy`,
      defaultMessage: `When sending a reminder about a scheduled ${sessionTerm}:`,
    },
    lblIceTimeStartCopy: {
      id: `${scope}.lblIceTimeStartCopy`,
      defaultMessage: `When initially notifying a ${athleteTerm} about a scheduled ${sessionTerm}:`,
    },
    lblWelcomeCopy: {
      id: `${scope}.lblWelcomeCopy`,
      defaultMessage: 'When you send out a welcome email for the assessment:'
    }
  })
};
